import { render } from "./AppElementsAreaWireframe.vue?vue&type=template&id=21ff8515"
import script from "./AppElementsAreaWireframe.vue?vue&type=script&lang=js"
export * from "./AppElementsAreaWireframe.vue?vue&type=script&lang=js"

import "./AppElementsAreaWireframe.vue?vue&type=style&index=0&id=21ff8515&lang=less"

import exportComponent from "D:\\PHPDev\\www\\xampp\\htdocs\\_projects\\q2e-2021\\themes\\q2e-2021\\src\\vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__